// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_EsforcoAgenteInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * POST /chamados/esforco-agente
 *
 * `esforco` vazio LIMPA a estimativa; qualquer outro valor tem de ser um de
 * `ChamadoEsforco`. Não há campo de autor nem de data: quem estimou é o JWT e
 * quando é o servidor.
 */
import { registerContract } from './validate'

export interface Chamados_EsforcoAgenteInput {
chamado_id: number
esforco?: string
}

registerContract('Chamados_EsforcoAgenteInput', {
  chamado_id: { type: 'number',  required: true },
  esforco:    { type: 'string',  required: false },
})
